/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GetAvailableStatusesDictionaryResponse } from '../models/GetAvailableStatusesDictionaryResponse';
import type { GetRegionDictionaryDataResponse } from '../models/GetRegionDictionaryDataResponse';
import type { GetSiteDictionaryDataResponse } from '../models/GetSiteDictionaryDataResponse';
import type { GetStudyDictionaryDataResponse } from '../models/GetStudyDictionaryDataResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class DictionaryService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetAvailableStatusesDictionaryResponse
     * @throws ApiError
     */
    public dictionaryGetAvailableStatusesDictionary(): Observable<GetAvailableStatusesDictionaryResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/dictionaries/available-statuses',
        });
    }
    /**
     * @returns string
     * @throws ApiError
     */
    public dictionaryGetTravelRequestsMerchantsDictionary(): Observable<Record<string, string>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/dictionaries/travelRequestMerchantTypes',
        });
    }
    /**
     * @returns string
     * @throws ApiError
     */
    public dictionaryGetPaymentRequestsMerchantsDictionary(): Observable<Record<string, string>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/dictionaries/paymentRequestMerchantTypes',
        });
    }
    /**
     * @returns GetStudyDictionaryDataResponse
     * @throws ApiError
     */
    public dictionaryGetStudyDictionaryData(): Observable<Array<GetStudyDictionaryDataResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/dictionaries/studies',
        });
    }
    /**
     * @returns GetSiteDictionaryDataResponse
     * @throws ApiError
     */
    public dictionaryGetSiteDictionaryData(): Observable<Array<GetSiteDictionaryDataResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/dictionaries/sites',
        });
    }
    /**
     * @returns GetRegionDictionaryDataResponse
     * @throws ApiError
     */
    public dictionaryGetRegionDictionaryData(): Observable<Array<GetRegionDictionaryDataResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/dictionaries/regions',
        });
    }
}
